export default "__VITE_ASSET__rGmw_jIj__"